import create from "zustand";

import type { AskPerformYardState } from "./types";

import { buildGreetingMessage, initialDocumentModalState, resetSessionId } from "./helpers";
import { createChatSlice } from "./slices/chat-slice";
import { createDocumentModalSlice } from "./slices/document-modal-slice";
import { createFeatureSlice } from "./slices/feature-slice";
import { createGoalSlice } from "./slices/goal-slice";
import { createScrollSlice } from "./slices/scroll-slice";
import { createUiSlice } from "./slices/ui-slice";
import { drainPendingChunks, setStoreRef } from "./streaming-buffer";

export const useAskPerformYardStore = create<AskPerformYardState>((set) => ({
	...createUiSlice(set),
	...createChatSlice(set),
	...createFeatureSlice(set),
	...createGoalSlice(set),
	...createDocumentModalSlice(set),
	...createScrollSlice(set),

	// Reset chat state (note: does not reset UI state like isOpen/isExpanded)
	resetChat: () => {
		drainPendingChunks();
		set((state) => ({
			sessionId: resetSessionId(),
			messages: [
				buildGreetingMessage(
					state.cachedAskHrEnabled,
					state.cachedGoalCreationEnabled,
					state.cachedFormCreationEnabled
				),
			],
			status: "idle",
			streamStage: null,
			streamMessage: null,
			error: null,
			inputValue: "",
			hasNoDocuments: false,
			goalSuggestionStates: [],
			creatingSuggestionIds: new Set<string>(),
			isCreatingAll: false,
			isGoalEditPanelOpen: false,
			activeEditMessageId: null,
			documentModal: initialDocumentModalState,
		}));
	},
}));

// Wire up the lazy store reference for the streaming buffer
setStoreRef(useAskPerformYardStore);
